import React, { useState } from 'react'

import { ConfirmationDialog } from '@scoir/modals'
import PropTypes from 'prop-types'
import { Prompt } from 'react-router-dom'

import { useHistory } from 'components/ReactRouterProvider/context'

const UnsavedPrompt = ({ hasChanges, isDirtyFunc }) => {
  const [nextLocation, setNextLocation] = useState('')
  const history = useHistory()

  const navConfirmed = () => {
    setNextLocation('')
    history.push(nextLocation)
  }

  return (
    <React.Fragment>
      <Prompt
        when={hasChanges && !nextLocation}
        message={(nextLocation) => {
          if (isDirtyFunc()) {
            setNextLocation(`${nextLocation.pathname}${nextLocation.search}`)
            return false
          }
          return true
        }}
      />
      <ConfirmationDialog
        headerText="Unsaved Changes"
        confirmationText="Continue Without Saving"
        open={!!nextLocation}
        onConfirm={navConfirmed}
        onClose={() => {
          setNextLocation('')
        }}
      >
        <strong>
          Warning! You are about to leave this page without saving your changes. Please note any updates you&apos;ve
          made to this page will be lost.
        </strong>
        <br />
        <br />
        If you are sure, proceed by clicking &apos;Continue Without Saving&apos;. If you would like to resume working
        you can press &apos;Cancel&apos;.
      </ConfirmationDialog>
    </React.Fragment>
  )
}

UnsavedPrompt.propTypes = {
  hasChanges: PropTypes.bool.isRequired,
  setHasChanges: PropTypes.func,
  isDirtyFunc: PropTypes.func.isRequired,
}

export default UnsavedPrompt
